export const Marquee = ({ items }) => {
  const doubled = [...items, ...items];
  return (
    <div data-testid="industries-marquee" className="relative overflow-hidden py-4 select-none">
      <div className="marquee">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="text-outline font-serif text-5xl md:text-7xl lg:text-8xl px-8">
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#0B1F3A]/30" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
